import { type CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { ModalHeaderWithClose } from '#src/assets/ui/shared/components/DialogHeader.tsx'

export function PreferencesModalHeader({
  t,
  onClose,
}: {
  t: CookieConsentTranslator
  onClose: () => void
}) {
  return (
    <ModalHeaderWithClose
      title={t('preferencesModalTitle')}
      titleId="lcc-preferences-title"
      closeLabel={t('closeIconLabel')}
      onClose={onClose}
    />
  )
}
